import React from "react";

const UserTable = ({ data, roleId, selectedIds, handleCheckboxChange,currentPage,pageSize }) => {

  return (
    <table border="1" cellPadding="10" className="border-0 w-100" style={{margin:"25px"}}>
      <thead>
        <tr>
          <th className="bg-light">Select</th>
          <th className="bg-light">SrNo</th>
          <th className="bg-light">Name</th>
          <th className="bg-light">Email</th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map((item, index) => (
            <tr key={item.id}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedIds.includes(item.email)}
                  onChange={(e) =>
                    handleCheckboxChange(item.email, e.target.checked)
                  }
                />
              </td>
              <td>{(currentPage - 1) * pageSize + (index + 1)}</td>
              <td>{item.first_name}</td>
              <td>{item?.email}</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default UserTable;
